import * as actions from './actions'
import * as alertsSelectors from '../../selectors';
import { default as BasicAlertModal, ValueProps, EventProps } from './BasicAlertModal'
import { selectors as authSelectors } from '../../../../lifecycle/auth'
import { Profile } from '../../../../remote-api/CoreServicesRemoteApi'
import { basicAlertModalSelectors } from './selectors'
import { AppState, Dispatch } from '../../../../types'
import { BasicAlert } from '../../model'
import { connect } from 'react-redux'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { User } from '../../../../remote-api/models'

const mapProps = (state: AppState): ValueProps => ({
  profile: authSelectors.getProfile(state).getOrUndefined() as Profile | undefined,
  organizationId: authSelectors.getOrganizationId(state),
  isBasicAlertModalOpened: basicAlertModalSelectors.isBasicAlertModalOpened(state),
  apiAlertsEnabled: alertsSelectors.isAPIBasicAlertsEnabled(state) && window.mc.featureFlags.alerts.apiAlerts.enabled === 'true',
  apiResponseCodesLimit: basicAlertModalSelectors.apiResponseCodesLimit(state),
  existingAlert: basicAlertModalSelectors.existingAlert(state),
  environmentSelector: basicAlertModalSelectors.environmentSelector.getAll(state),
  resourceSelector: basicAlertModalSelectors.resourceSelector.getAll(state),
  versionSelector: basicAlertModalSelectors.versionSelector.getAll(state),
  servers: basicAlertModalSelectors.servers(state),
  serversLoading: basicAlertModalSelectors.serversLoading(state),
  serverApplications: [],
  users: basicAlertModalSelectors.users(state),
  emailTemplateEnabled: window.mc.featureFlags.alerts.emailTemplate.enabled === 'true',
  hasEditRole: authSelectors.hasEditRole(state),
  isBasicAlertsLimitExceeded: alertsSelectors.isBasicAlertsLimitExceeded(state),
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  load: (envId?: string, resId?: string, versionId?: string, targetId?: string, resType?: ResourceType) => {
    dispatch(actions.load(envId, resId, versionId, targetId, resType))
    if (envId) {
      dispatch(actions.fetchServers(envId))
    }
  },
  fetchUsers: (search: string, limit: number, offset: number) => dispatch(actions.fetchUsers(search, limit, offset)),
  changeUsers: (users: User[]) => dispatch(actions.changeUsers(users)),
  environmentSelected: (environmentId: string) => dispatch(actions.environmentSelected(environmentId)),
  resourceSelected: (resourceId: string, resourceType: ResourceType) => dispatch(actions.resourceSelected(resourceId, resourceType)),
  versionSelected: (versionId: string) => dispatch(actions.versionSelected(versionId)),
  saveBasicAlert: (alert: BasicAlert) => dispatch(actions.saveBasicAlert(alert)),
  deleteBasicAlert: (alert: BasicAlert) => dispatch(actions.deleteBasicAlert(alert)),
  handleOpen: () => dispatch(actions.handleOpen()),
  handleClose: () => dispatch(actions.handleClose()),
  cleanResourcesSelectors: () => dispatch(actions.cleanResourcesSelectors()),
})

export default connect(mapProps, mapDispatch)(BasicAlertModal)
